import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import headerImg from "./assets/key-art_Desktop.png";
import headerImgMb from "./assets/key-art_mobile.jpg";
import aboutImg from "./assets/about.png";


//TODO: EVENT_ID
const EVENT_ID = "c0001";

//TODO: aboutWalkContent
const aboutWalkContent = `在二次世界大戰期間，台灣作為日本的殖民地，被深深捲入東亞戰場的戰爭動員體系。當時，台灣不僅成為兵源與勞動力的供應地，也作為南進作戰的重要軍事據點，設有多處軍事設施，包括機場、防空壕與碉堡等。台中地區尤為關鍵，是日軍在台的重要空軍基地之一，戰時遺址至今仍隱藏於城市與山林之間，見證了台灣人在戰火中所經歷的動員、服役、被迫參戰乃至犧牲。
2025年舉辦的第27回夏季學校走讀行程即以「戰爭記憶・中台尋跡」為主題，實地走訪清泉崗、大肚山、台中市區與霧峰地區的二戰歷史現場，包括：原日軍臺中飛行場機槍堡、3102高地與見晴臺的防禦設施、台中車站周邊的防空壕與碉堡群、寶覺禪寺的靈安故鄉碑（紀念台籍兵魂歸故土）及霧峰的民生故事館。每一站均安排專家學者現場導覽，帶領學員從戰爭遺構中追尋歷史記憶。
透過本次走讀，不僅讓參與者看見台灣人在戰爭中所承受的命運，也思考戰爭如何形塑了台灣的歷史與身分認同。我們希望藉由親身踏查與深度對話，讓這段被遺忘或模糊的歷史，再次浮現於公共記憶之中，並重新書寫屬於台灣的戰爭史觀。`;

//TODO: credit
const credit = `
<div>
    團隊介紹：財團法人吳三連台灣史料基金會與台中霧峰明台高中於2001年恢復舉辦由林獻堂創立的夏季學校，至2025年已歷經25年，共辦理27回。2025年適逢二戰結束80週年，27回夏季學校以「戰爭記憶 中台尋跡」為主題，規畫相關研習課程及走讀行程，期能喚回民眾對二戰的集體記憶，並清楚重建及形塑真正屬於台灣人的史觀。<br>
    財團法人吳三連台灣史料基金會成立至今，舉凡史料的蒐集、書籍的出版、活動的舉辦、專案的推動等等，萬流歸宗，為的是台灣史能真正的回歸台灣土地與人民之上，茁壯發展。基金會自成立以來在各方的協助下，會務工作已有了一定的成績。展望未來，除了秉持「甘願做牛不怕無犁可拖」的精神繼續推動會務之外，我們最大的願望就是成立一所專業的台灣史圖書館，讓屬於台灣的史料能有一個安身立命、長治久安的歸宿，不再流浪、不再塵封、不再無依無靠。這個心願，我們期待更多人的投入，當夢想成真的那一天，就是台灣史的耕耘開花結果的那一天。聯絡電話(02)27122836
    <br>
    <br>
    本圖臺是由財團法人吳三連台灣史料基金會及智紳數位文化有限公司共同協力建置：
    <br>1. 圖臺內容：財團法人吳三連台灣史料基金會
    <br>2. 圖臺系統開發：智紳數位文化事業有限公司
    <br>
    <br>除另有聲明外，本網站內容採用創用 CC 姓名標示-非商業性-相同方式分享4.0授權條款授權公眾使用，您可以依授權條款複製、引用、轉載，唯請於合理位置標示本站網址：財團法人吳三連台灣史料基金會<a href='https://www.twcenter.org.tw'>https://www.twcenter.org.tw</a>
</div>
`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [
      { county: "臺中市", town: "西屯區" },
      { county: "臺中市", town: "北屯區" },
      { county: "臺中市", town: "北區" },
      { county: "臺中市", town: "霧峰區" },
    ], //TODO: weather 氣象預測地點
  },
  themeConfig: {
    "--dui-primary": "#459AF8", //TODO: theme
    "--dui-accent": "#8F4A91", //TODO: 數位集章按鈕顏色, more按鈕
    "--dui-secondary": "#459AF8", //TODO: theme
    "--dui-bg-secondary": "#ffc361", // Dialog background
    "--dui-bg-accent": "#405268", //TODO: background
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};
// #e4e7cb
// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);
  return (
    <div className="root">
      <DguideWalksApp
      language="zh-TW"
      //! 左側數位集章選項
      // mainMenuChildren={
      //   <MenuItemWithDialog
      //     Icon={Checkin}
      //     title="路線顏色"
      //     active={dui.activeMenuId === '數位集章'}
      //     {...dui.menuSwitcherAction('數位集章')}
      //   >
      //     {/* {dui.activeMenuId === '數位集章' && (
      //       <iframe
      //         style={{ height: '100%', border: 0, borderRadius: '5px' }}
      //         src={`https://map.jsdc.com.tw/tools/checkin/${EVENT_ID}/showlist.php?a=${EVENT_ID}`}
      //       ></iframe>
      //     )} */}
      //     //? 設定線條顏色
      //     {paths.map(path => (
      //       <div
      //         key={path.name}
      //         style={{
      //           display: 'flex',
      //           alignItems: 'center',
      //           margin: '20px',
      //         }}
      //       >
      //         <div
      //           style={{
      //             width: '50px',
      //             height: '5px',
      //             backgroundColor: path.color,
      //             alignItems: 'center',
      //             marginRight: '10px',
      //           }}
      //         ></div>
      //         <span
      //           style={{
      //             fontSize: '20px',
      //             color: '#000',
      //             // fontWeight: "bold",
      //           }}
      //         >{` ：${path.name}`}</span>
      //       </div>
      //     ))}
      //   </MenuItemWithDialog>
      // }
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        //TODO: map view bound
        latLng(24.244313, 120.501991),
        latLng(24.036284, 120.72515),
      ),
      maxZoom: 19,
    }),
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider
        Jsdc={Jsdc}
        config={config}
      >
        <DuiContextProvider {...duiConfigProps}>
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
